import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import fetchFeedingGuidelinesBodyConditionAction from './../../store/actions/fetch/fetchFeedingGuidelinesBodyConditionAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesBodyConditionAction';
import BodyCondition from './../../components/FeedingGuidelines/BodyCondition/BodyCondition';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesBodyCondition extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-body-condition');
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-body-condition'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, pending, ready, error, output} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>

        <BodyCondition
          data={data}
          output={output}/>

      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesBodyConditionReducer.data,
    pending: state.feedingGuidelinesBodyConditionReducer.pending,
    ready: state.feedingGuidelinesBodyConditionReducer.ready,
    error: state.feedingGuidelinesBodyConditionReducer.error,
    screenshots: state.pdfOutputReducer.images,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesBodyConditionAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-body-condition',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesBodyCondition);
